import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { filterCommonAttributes } from '../../ai-answer-dialog/analytics-helpers';
import { KeyPhraseCategory } from './api/useAutohighlightSupplier';
import { getHighlightCategories } from './common/utils';
export var onCuratedDefinitionUpdateButtonClicked = function onCuratedDefinitionUpdateButtonClicked(_ref) {
  var commonAttributes = _ref.commonAttributes,
    newDefinition = _ref.newDefinition,
    restrictedScope = _ref.restrictedScope,
    sourceSelected = _ref.sourceSelected,
    aiDefinitionEdited = _ref.aiDefinitionEdited;
  var keyPhrase = commonAttributes.query,
    oldDefinition = commonAttributes.answerString,
    extraAttributes = commonAttributes.extraAttributes,
    source = commonAttributes.source;
  var _ref2 = extraAttributes || {},
    contentId = _ref2.contentId,
    readingAidsSessionId = _ref2.readingAidsSessionId;
  return {
    action: 'clicked',
    actionSubject: 'aiCuratedDefinitionUpdateButton',
    source: source,
    eventType: 'ui',
    attributes: {
      contentId: contentId,
      readingAidsSessionId: readingAidsSessionId,
      restrictedScope: restrictedScope,
      sourceSelected: sourceSelected,
      newDefinitionLength: newDefinition.length,
      // whether the user is editing an AI answer or already edited definition
      aiDefinitionEdited: aiDefinitionEdited
    },
    nonPrivacySafeAttributes: {
      keyPhrase: keyPhrase,
      oldDefinition: oldDefinition,
      newDefinition: newDefinition
    }
  };
};
export var onCuratedDefinitionSeeEditHistoryButtonClicked = function onCuratedDefinitionSeeEditHistoryButtonClicked(props) {
  var query = props.query,
    answerString = props.answerString,
    extraAttributes = props.extraAttributes,
    source = props.source;
  var _ref3 = extraAttributes || {},
    contentId = _ref3.contentId,
    readingAidsSessionId = _ref3.readingAidsSessionId;
  return {
    action: 'clicked',
    actionSubject: 'aiCuratedDefinitionSeeEditHistoryButton',
    source: source,
    eventType: 'ui',
    attributes: {
      contentId: contentId,
      readingAidsSessionId: readingAidsSessionId
    },
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};
export var onLikeButtonClick = function onLikeButtonClick(props) {
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerLikeButton',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};
export var onDislikeButtonClick = function onDislikeButtonClick(props) {
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerDislikeButton',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};
export var onShownAutoDefinitionHighlights = function onShownAutoDefinitionHighlights(_ref4) {
  var product = _ref4.product,
    contentId = _ref4.contentId,
    keyPhrases = _ref4.keyPhrases,
    fieldType = _ref4.fieldType;
  return {
    action: 'shown',
    actionSubject: 'aiDefinitionsAutohighlights',
    source: 'viewPageScreen',
    eventType: 'track',
    attributes: {
      product: product,
      contentId: contentId,
      numHighlights: keyPhrases.length,
      categories: getHighlightCategories(keyPhrases),
      beAcronymsEnabled: true,
      fieldType: fieldType
    }
  };
};
export var onClickAutoDefinitionHighlights = function onClickAutoDefinitionHighlights(_ref5) {
  var contentId = _ref5.contentId,
    sessionId = _ref5.sessionId,
    keyPhraseCategory = _ref5.keyPhraseCategory,
    fieldType = _ref5.fieldType;
  return {
    action: 'clicked',
    actionSubject: 'aiDefinitionsAutohighlights',
    source: 'viewPageScreen',
    eventType: 'ui',
    attributes: {
      contentId: contentId,
      readingAidsSessionId: sessionId,
      keyPhraseCategory: keyPhraseCategory || KeyPhraseCategory.AUTO,
      fieldType: fieldType
    }
  };
};
export var onClickDisableDefinition = function onClickDisableDefinition(props) {
  return {
    action: 'clicked',
    actionSubject: 'aiDefinitionsDisableDefinition',
    source: 'viewPageScreen',
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props))
  };
};